// import UserInfoComponent from "../Components/homepageComponents/UserInfoComponent";
// import { useAppContext } from "../AppContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getOneProjectItem } from "../../api/api";
import { Row, Col } from "react-bootstrap";
import InnerPageLayoutProjects from "../../Components/Layout/InnerPageLayoutProjects";
import ProjectNewsShowcase from "./ProjectNewsShowcase";
import ProjectLibraryWidget from "./ProjectLibraryWidget";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faInfoCircle,
  faMapMarkedAlt,
  faNewspaper,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import { styled } from "styled-components";
import { TailSpin } from "react-loader-spinner";
import { IInnerProject } from "../../types/inner_page";
import ProjectsSliderComponent from "./ProjectsSliderComponent";
import i18n from "../../i18n";
import { ClassName } from "react-calendar/dist/cjs/shared/types";
import { Link } from "react-router-dom"; 

const SideNav = () => {
  const [activeSection, setActiveSection] = useState("section-home");

  const scrollToSection = (sectionId: string) => {
    setActiveSection(sectionId);
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="side-nav">
      <button
        className={`nav-button ${
          activeSection === "section-home" ? "active" : ""
        }`}
        onClick={() => scrollToSection("section-home")}
      >
        <FontAwesomeIcon icon={faHome} />
      </button>
      <button
        className={`nav-button ${
          activeSection === "section-info" ? "active" : ""
        }`}
        onClick={() => scrollToSection("section-info")}
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </button>
      <button
        className={`nav-button ${
          activeSection === "section-map" ? "active" : ""
        }`}
        onClick={() => scrollToSection("section-map")}
      >
        <FontAwesomeIcon icon={faMapMarkedAlt} />
      </button>
      <button
        className={`nav-button ${
          activeSection === "section-news" ? "active" : ""
        }`}
        onClick={() => scrollToSection("section-news")}
      >
        <FontAwesomeIcon icon={faNewspaper} />
      </button>
      <button
        className={`nav-button ${
          activeSection === "section-files" ? "active" : ""
        }`}
        onClick={() => scrollToSection("section-files")}
      >
        <FontAwesomeIcon icon={faFileAlt} />
      </button>
    </div>
  );
};

const TarabutWidget = ({ pageItem }: { pageItem: IInnerProject }) => {
  const { t, i18n } = useTranslation();
  const survey = pageItem.attributes.surveyLink;

  return (
    <>
      {survey ? (
        <Row className="">
          <Col sm={9}>
            <Row className="tarabut-widget-row-new">
              <Col>
                <h3 className="text-center mb-3">
                  {pageItem.attributes.aboutProjectTitle}
                </h3>
                {pageItem.attributes.aboutProjectDescrption}
              </Col>
            </Row>
          </Col>
          <Col sm={3}>
            <Col
              style={{
                backgroundColor: "#FFF",
                padding: "5px",
                textAlign: "center",
              }}
            >
              {/* <a href={survey} target="_blank"> */}
              {/* <a href={'/TarabutSurvey'} target="_blank"> */}
              <Link to={'TarabutSurvey'} >
                 <img
                  src={`https://eportal-admin.rafedsa.com/uploads/tarabot_survay_b4936b770d.png`}
                  width={"90%"}
                  alt={"survay"}
                />
                {t("tarabut_survey")}
                </Link>
              {/* </a> */}
            </Col>
          </Col>
        </Row>
      ) : (
        <>
          <Row className="tarabut-widget-row-new">
            <Row className="">
              <Col>
                <h3 className="text-center mb-3">
                  {pageItem.attributes.aboutProjectTitle}
                </h3>
                {pageItem.attributes.aboutProjectDescrption}
              </Col>
            </Row>
          </Row>
        </>
      )}

      <Row>
        {pageItem.attributes.aboutProjectImage?.data?.attributes?.url && (
          <div className="tarabut-widget-image">
            {pageItem.attributes.aboutProjectImage?.data?.attributes?.url ? (
              <img
                src={`${process.env.REACT_APP_CMS}${pageItem.attributes.aboutProjectImage.data.attributes.url}`}
                alt={pageItem.attributes.aboutProjectTitle}
              />
            ) : (
              <p>{i18n.t("Image_not_available")}</p> // Fallback text if image URL is missing
            )}
          </div>
        )}
      </Row>
    </>
  );
  /*
  return (
    <Row className="tarabut-widget-row">
      <div className="tarabut-widget-content">
        <p className="text-center mb-4">
          {survey ? (
            <>
              <Row>
                <Col sm={9}>
                  <h3 className="text-center mb-3">
                    {pageItem.attributes.aboutProjectTitle}
                  </h3>
                  {pageItem.attributes.aboutProjectDescrption}{" "}
                </Col>
                <Col sm={3} style={{ backgroundColor: "#FFF", padding: "5px" }}>
                  <a href={survey} target="_blank">
                    <img
                      src={`https://eportal-admin.rafedsa.com/uploads/tarabot_survay_b4936b770d.png`}
                      width={"90%"}
                      alt={"survay"}
                    />
                    {t("tarabut_survey")}
                  </a>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col sm={12}>
                  <h3 className="text-center mb-3">
                    {pageItem.attributes.aboutProjectTitle}
                  </h3>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>{pageItem.attributes.aboutProjectDescrption} </Col>
              </Row>
            </>
          )}
        </p>
      </div>

      {pageItem.attributes.aboutProjectImage?.data?.attributes?.url && (
        <div className="tarabut-widget-image">
          {pageItem.attributes.aboutProjectImage?.data?.attributes?.url ? (
            <img
              src={`${process.env.REACT_APP_CMS}${pageItem.attributes.aboutProjectImage.data.attributes.url}`}
              alt={pageItem.attributes.aboutProjectTitle}
            />
          ) : (
            <p>{i18n.t("Image_not_available")}</p> // Fallback text if image URL is missing
          )}
        </div>
      )}
    </Row>
  );
  */
};
const TarabutJourneyWidget = ({ pageItem }: { pageItem: IInnerProject }) => {
  return (
    <Row className="tarabut-journey-widget-row">
      <div className="tarabut-journey-widget-content">
        <h3 className="text-center mb-3">
          {pageItem.attributes.section2Title}
        </h3>
      </div>
      <div className="tarabut-journey-widget-image">
        {pageItem.attributes.section2Image?.data?.attributes?.url ? (
          <img
            src={`${process.env.REACT_APP_CMS}${pageItem.attributes.section2Image.data.attributes.url}`}
            alt={pageItem.attributes.section2Title}
          />
        ) : (
          <p>{i18n.t("Image_not_available")}</p> // Fallback text if image URL is missing
        )}
      </div>
    </Row>
  );
};

function ProjectPage() {
  let { id } = useParams();

  const { i18n, t } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    `innerProjectData-${id}`,
    () => getOneProjectItem({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <TailSpin color="#ffffff" height={70} width={70} />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (error)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );
  let pageItem: IInnerProject = data["data"];

  if (i18n.language === "en") {
    const localizations = data["data"]["attributes"]["localizations"]["data"];
    const enLocalization = localizations.find(
      (loc: any) => loc["attributes"]["locale"] === "en"
    );

    if (enLocalization) {
      pageItem = enLocalization;
    }
  }

  return (
    <InnerPageLayoutProjects>
      <>
        <SideNav />

        <section id="section-home" className="content-section">
          <ProjectsSliderComponent isRtl={true} pageItem={pageItem} />
        </section>

        <section id="section-info" className="content-section">
          <TarabutWidget pageItem={pageItem} />
        </section>

        <section id="section-map" className="content-section">
          <TarabutJourneyWidget pageItem={pageItem} />
        </section>

        <section id="section-news" className="content-section">
          <ProjectNewsShowcase limit={6} pageItem={pageItem} />
        </section>

        <section id="section-files" className="content-section">
          <ProjectLibraryWidget pageItem={pageItem} />
        </section>
      </>
    </InnerPageLayoutProjects>
  );
}

const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ProjectPage;
